/*
 * @Author: cc
 * @LastEditTime: 2025-12-22 10:20:43
 */
import { Button, Input, Modal, message } from 'antd';
import { encode } from 'js-base64';
import { useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { post } from '../../../component/fetch';
import { isPc } from '../../../utils/index';
import Login from '../login';
import SetPassword from '../setPassword';
import './index.scss';
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const { REACT_APP_BASE_PC_URL, REACT_APP_BASE_MOBILE_URL } = process.env;
// const { Search } = Input;
/** 独立密码登录页面组件*/
function Index(props: any) {
  const query = useQuery();
  const projectId = query.get('projectId');
  const [mobile, setMobile] = useState('');
  const [step, setStep] = useState(1);
  const [prevStep, setPrevStep] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { projectPasswordLoginType } = props.initData;
  /**第一步登录事件 */
  function loginOnice() {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (!reg.test(mobile)) {
      message.error('请输入正确的手机号码');
      return;
    }
    post('/user/api/user/checkUserMobile', { userName: encode(mobile), projectId: projectId }, true)
      .then(res => {
        if (res.code === 0) {
          setPrevStep(step);
          setStep(3);
        }
      })
      .catch(err => {
        if (err.code === 2011) {
          setPrevStep(step);
          setStep(2);
        }
      });
  }
  /**设置密码确认事件回调 */
  function setPassword(val: any) {
    const { mobile, smsCode, password } = val;
    const data = {
      userName: mobile,
      projectId,
      smsCode,
      password,
    };
    post('/user/api/user/set/password', data, true).then(res => {
      if (res.code === 0) {
        setPrevStep(step);
        message.success('设置成功');
        projectPasswordLoginType === 1 ? setStep(3) : setStep(1);
      } else {
        message.error(res.msg);
      }
    });
  }
  /**登录事件 */
  function loginSubmit(val: any) {
    const { mobile, randomCode, password } = val;
    const data = {
      userName: mobile,
      projectId,
      randomCode,
      password,
    };
    post('/user/api/user/login', data, true).then(res => {
      if (res.code === 0) {
        if (isPc) {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_PC_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_PC_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        } else {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_MOBILE_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_MOBILE_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        }
      }
    });
  }
  return (
    <div style={{ padding: '0 20px', height: '100%' }}>
      {projectPasswordLoginType === 1 && (
        <>
          {step === 1 && (
            <div style={{ height: '100%' }}>
              <h3 style={{ color: '#1677ff' }}>登录</h3>
              <div className="independentContent">
                <Input
                  value={mobile}
                  onChange={(e: any) => {
                    setMobile(e.target.value);
                  }}
                  placeholder="请输入手机号码"
                ></Input>
                <p style={{ marginTop: '20px', width: '100%' }}>
                  <Button
                    style={{ width: '100%' }}
                    type="primary"
                    onClick={() => {
                      loginOnice();
                    }}
                  >
                    下一步
                  </Button>
                </p>
              </div>
            </div>
          )}
          {step === 2 && (
            <SetPassword
              goBack={() => {
                setStep(prevStep);
              }}
              mobile={mobile}
              mobileDisabled={true}
              submit={(val: Object) => setPassword(val)}
              sendCodeInterface="/user/api/user/sendSmsCode"
            ></SetPassword>
          )}
          {step === 3 && (
            <>
              <h3 style={{ color: '#1677ff' }}>登录</h3>
              <Login
                mobile={mobile}
                mobileDisabled={true}
                submit={(val: Object) => loginSubmit(val)}
              ></Login>
              {projectId !== '3594' && projectId !== '3593' && (
                <p style={{ textAlign: 'right', color: '#1677ff' }}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setPrevStep(step);
                      setStep(2);
                    }}
                  >
                    忘记密码?
                  </a>
                </p>
              )}
            </>
          )}
        </>
      )}
      {projectPasswordLoginType === 2 && (
        <>
          {step === 1 && (
            <div>
              <h3 style={{ color: '#1677ff' }}>登录</h3>
              <Login submit={(val: Object) => loginSubmit(val)}></Login>
              {projectId !== '3594' && projectId !== '3593' && (
                <p style={{ textAlign: 'right', color: '#1677ff' }}>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setPrevStep(step);
                      setStep(2);
                    }}
                  >
                    忘记密码?
                  </a>
                </p>
              )}
            </div>
          )}

          <Modal
            title={props.initData.onlineServiceText}
            open={isModalOpen}
            footer={null}
            onCancel={() => {
              setIsModalOpen(false);
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: props.initData.onlineServiceContent,
              }}
            ></div>
          </Modal>
          {step === 2 && (
            <SetPassword
              goBack={() => {
                setStep(prevStep);
              }}
              submit={(val: Object) => setPassword(val)}
              sendCodeInterface="/user/api/user/sendSmsCode"
            ></SetPassword>
          )}
          {props.initData.onlineServiceFlag !== 0 && (
            <p style={{ textAlign: 'center', color: '#1677ff' }}>
              <a style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
                {props.initData.onlineServiceName ? props.initData.onlineServiceName : '在线客服'}
              </a>
            </p>
          )}
        </>
      )}
    </div>
  );
}
const getInitData = (state: { initData: Array<any> }) => {
  return {
    initData: state.initData,
  };
};
export default connect(getInitData)(Index);
